import { __callbacks } from "../Callbacks/Callback";
import { __chats } from "../Chats/Chats";
import { __delay } from "../Delay/Delay";
import { IChatMessageFragment, IChatMsgAPI } from "../Interfaces";

/**
 * Queue class
 */
export class Queue<T = any> {
    private chatId: string = "";
    /**
     * self queue
     */
    private self: T[] = [];
    /**
     * Size of the queue
     */
    public get length(): number {
        return this.self.length;
    }

    /**
     * Queue constructor
     * @param chatId string
     */
    constructor(chatId: string) {
        this.chatId = chatId;
    }

    /**
     * adds an item
     * @param item T
     */
    add = (item: T) => {
        this.self.push(item);

        // trigger callback for unread messages
        __callbacks.unreadMsgs.trigger({
            chatId: this.chatId,
            unreadMsgs: this.length,
            msgs: [...this.self]
        });

        // check if the chat is open
        if (__chats.getCurrentChatId() !== this.chatId) {
            //console.log(`chat with id [${this.chatId}] is not open!`);
            this.broadcastEvents();
        }
    }

    /**
     * broadcasts/updates/triggers/refreshes events
     * @returns void
     */
    broadcastEvents = () => {
        const item = this.self[this.self.length - 1];
        if (!item) return;

        const chatMsg: IChatMsgAPI = (item as any);
        const userProps = {
            userId: chatMsg.userId,
            userName: chatMsg.userName,
            userPhoto: chatMsg.userPhoto,
        }
        const lastFragment: IChatMessageFragment = {
            id: "",
            chatId: chatMsg.chatId,
            messageNo: 0,
            messageType: chatMsg.messageType,
            fragmentType: chatMsg.child.componentName,
            time: chatMsg.time,
            props: { ...chatMsg.child.props, ...userProps }
        };
        __delay.set(
            "Queue_add",
            () => {
                __callbacks.chatMessage.trigger({
                    chatId: chatMsg.chatId,
                    lastFragment: lastFragment
                });
            },
            1000
        );
    }

    /**
     * returns the items in the queue  
     * also empties the queue  
     * @returns T[]
     */
    resolve = (): T[] => {
        // trigger callback
        __callbacks.unreadMsgs.trigger({
            chatId: this.chatId,
            unreadMsgs: 0
        });

        const self = [...this.self];
        this.empty();
        return self;
    }

    /**
     * removes an item
     * @returns T | undefined
     */
    remove = (): T | undefined => {
        return this.self.shift()
    }

    /**
     * empties itself
     */
    empty = () => {
        this.self = [];
    }

    /**
     * returns self array
     * @returns T[]
     */
    get = (): T[] => {
        return this.self;
    }

    /**
     * sets self array
     * @param self T[]
     */
    set = (self: T[]) => {
        this.self = [...self];
    }
}

// test code
// const q = new Queue<number>("abc");
// q.add(1);
// console.log(q.length);
// console.log(q.remove());
// q.empty();
// console.log(q.length);
